import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';

import { FeatureFlagService } from '@core/services/feature-flag.service';
import { FeatureFlag } from '@env/environment.interface';
import { Company } from '@features/contacts/models';
import { CompanyService } from '@features/contacts/services/company.service';
import {
  DialogButtonColour,
  DialogComponent
} from '@shared/components/dialog/dialog.component';
import { ModalSetting } from '@shared/components/modal/modal-setting';

@Component({
  selector: 'spark-contacts-company-summary-panel',
  templateUrl: './company-summary-panel.component.html',
  styleUrls: ['./company-summary-panel.component.scss']
})
export class CompanySummaryPanelComponent {
  @Input() companySummary!: Company.CompanySummary;

  modal: BsModalRef | null = null;

  constructor(
    private companyService: CompanyService,
    private modalService: BsModalService,
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  get contactDeletionEnabled(): boolean {
    return this.featureFlagService.isEnabled(FeatureFlag.ContactDeletion);
  }

  delete(): void {
    const initialState = {
      title: 'Delete Contact',
      message: 'This action cannot be undone.',
      buttons: [
        {
          label: 'Cancel',
          action: of([]),
          complete: () => this.closeModal(),
          colour: DialogButtonColour.default
        },
        {
          label: 'Delete',
          action: this.companyService.deleteCompany(this.companySummary.id),
          complete: () => this.closeAndReturnToList(),
          colour: DialogButtonColour.danger
        }
      ]
    };
    this.modal = this.modalService.show(
      DialogComponent,
      ModalSetting.createDialog(initialState)
    );
  }

  closeModal() {
    this.modal?.hide();
  }

  closeAndReturnToList() {
    this.closeModal();
    this.router.navigate(['Contacts']);
  }
}
